import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const FileName = forwardRefAs((_a, ref) => {
    var { className } = _a, rest = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(Generic, Object.assign({ className: classNames("file-name", className), ref: ref }, rest)));
}, { as: "span" });
FileName.displayName = "File.Name";
//# sourceMappingURL=file-name.js.map